import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTutorials } from '../Tutorial/useTutorials';
import TutorialFloatingPlayer from '../Tutorial/TutorialFloatingPlayer';

const TutorialButton = ({ slotKey, className = '' }) => {
  const { t } = useTranslation();
  const { getSlotVideo } = useTutorials();
  const [activeVideo, setActiveVideo] = useState(null);
  const [isMinimized, setIsMinimized] = useState(false);

  const video = slotKey ? getSlotVideo(slotKey) : null;

  const handleClick = useCallback(() => {
    if (!video) return;
    setActiveVideo(video);
    setIsMinimized(false);
  }, [video]);

  const handleClose = useCallback(() => {
    setActiveVideo(null);
    setIsMinimized(false);
  }, []);

  const handleToggleMinimize = useCallback(() => {
    setIsMinimized(prev => !prev);
  }, []);

  // Don't render if no slotKey provided or no video assigned to this slot
  if (!slotKey || !video) return null;

  return (
    <>
      <button
        type="button"
        className={`tutorial-btn ${className}`}
        onClick={handleClick}
      >
        <span className="tutorial-btn__circle">
          <span className="tutorial-btn__play-icon">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 2.5V13.5L13 8L4 2.5Z" fill="#105235" />
            </svg>
          </span>
        </span>
        <span className="tutorial-btn__text">
          {t('common|Tutorial', 'Tutoriel')}
        </span>
      </button>

      {activeVideo && (
        <TutorialFloatingPlayer
          video={activeVideo}
          isMinimized={isMinimized}
          onClose={handleClose}
          onToggleMinimize={handleToggleMinimize}
        />
      )}
    </>
  );
};

export default TutorialButton;
